module.exports = __webpack_public_path__ + "static/media/47.d369c28d.jpg";